export const REPORT_STATUS = {
  draft: 'draft',
  inTrip: 'in_trip',
  sent: 'sent',
  closed: 'closed',
} as const

export type ReportStatus = (typeof REPORT_STATUS)[keyof typeof REPORT_STATUS]

export const REPORT_STATUS_LABELS: Record<string, string> = {
  draft: 'Черновик',
  in_trip: 'В рейсе',
  sent: 'Отправлен',
  closed: 'Закрыт',
}

export const REPORT_STATUS_FILTER_LABELS: Record<string, string> = {
  draft: 'Черновики',
  in_trip: 'В рейсе',
  sent: 'Отправленные',
  closed: 'Закрытые',
}

export const REPORT_STATUS_FILTER_ITEMS = [
  REPORT_STATUS.draft,
  REPORT_STATUS.inTrip,
  REPORT_STATUS.sent,
  REPORT_STATUS.closed,
] as const

/** Статусы общих отчётов (без «В рейсе») */
export const REPORT_COMMON_STATUS_FILTER_ITEMS = [
  REPORT_STATUS.draft,
  REPORT_STATUS.sent,
  REPORT_STATUS.closed,
] as const

export function getReportStatusLabel(status?: string | null) {
  if (!status) return ''
  return REPORT_STATUS_LABELS[status] || ''
}

export function isDraftStatus(status?: string | null) {
  return status === REPORT_STATUS.draft
}

export function isInTripStatus(status?: string | null) {
  return status === REPORT_STATUS.inTrip
}

/** Черновик или «В рейсе» — незакрытый путевой */
export function isOpenReportStatus(status?: string | null) {
  return isDraftStatus(status) || isInTripStatus(status)
}

export function isSentOrClosedStatus(status?: string | null) {
  return status === REPORT_STATUS.sent || status === REPORT_STATUS.closed
}
